<template>
  <AppRadioGroup :label="$tt('image_upload_prefer')" inline bold-label>
    <AppRadio v-for="(option, key) in options" :value="key" :label="$tt(option)" :key />
  </AppRadioGroup>
</template>

<script setup lang="ts">
import type { I18nKey } from '~/helpers/locale';
import type { FileTransferMethod } from '~/types';

const options: Record<FileTransferMethod, I18nKey> = {
  form: 'upload_images_now',
  whatsapp: 'whatsapp',
  email: 'email',
  later: 'send_images_later'
};
</script>